import React from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { useRootStore } from "../../../../store/contexts";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { FormSaveFooter } from "../../../../common/controls/forms/FormSaveFooter";

import FormExtras from "../../../../common/components/formExtras";
import { InterpreterCreateStore } from "../../store";
import { InputString } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type InterpreterCreateFormProps = {
  onSave?: () => void;
  onCancel?: () => void;
  /** Mientras se guarda, Guardar queda deshabilitado. */
  saving?: boolean;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
  nameSelectedValue?: { displayId: string; id: string } | null;
  onNameChange?: (value: string) => void;
  name: string;
  nameError?: string;
  interpreterCreateStore: InterpreterCreateStore;
};

export const InterpreterCreateForm: React.FC<InterpreterCreateFormProps> =
  observer(
    ({
      onSave = () => {},
      onCancel = () => {},
      saving = false,
      showToolbox = true,
      showSaveFooter,
      name = "",
      nameError,
      onNameChange = () => {},
      interpreterCreateStore,
    }) => {
      const rootStore = useRootStore();
      const { langStore } = rootStore;

      return (
        <Grid>
          {showToolbox && (
            <FormToolbox
              saveAndCloseLabel={langStore.saveEntity}
              closeLabel={langStore.cancelNewEntity}
              saveForm={() => onSave()}
              saveDisabled={saving}
              closeForm={() => onCancel()}
            />
          )}
          <Box>
            <FormExtras
              entity="Interpreter"
              mode="create"
              values={{}}
              options={{}}
              onPatch={(campo: string, valor: any) => {
                switch (campo) {
                  case "name":
                    onNameChange?.(valor);
                    break;
                }
              }}
            />
            <GroupContainer
              id="null"
              errorText={interpreterCreateStore.getCardErrors("null")}
              title={langStore.groupInterpreterLabel}
              collapsible={true}
            >
              <FormControl fullWidth>
                <InputString
                  autoFocus
                  value={name}
                  error={Boolean(nameError)}
                  warning={
                    !nameError &&
                    Boolean(interpreterCreateStore.warnings["name"])
                  }
                  helperText={
                    nameError ||
                    interpreterCreateStore.warnings["name"]?.message
                  }
                  label={langStore.InterpreterNameLabel}
                  onChange={(value: string) => onNameChange(value)}
                  description={langStore.InterpreterNameDescription}
                />
              </FormControl>
            </GroupContainer>

            <GroupContainer
              id="systemDates"
              errorText={interpreterCreateStore.getCardErrors("systemDates")}
              title={langStore.groupInterpreterSystemDatesLabel}
              collapsible={true}
              expanded={interpreterCreateStore.getCardState("systemDates")}
              toggleExpand={() =>
                interpreterCreateStore.toggleCardState("systemDates")
              }
            >
              <FormControl fullWidth></FormControl>
            </GroupContainer>
          </Box>
          {(showSaveFooter ?? !showToolbox) && (
            <FormSaveFooter
              onSave={() => onSave()}
              label={langStore.saveEntity}
              disabled={saving}
            />
          )}
        </Grid>
      );
    }
  );
